module.exports = __webpack_public_path__ + "img/midBanner02.43063838.png";